import {
  GET_ADMIN_CHANGE_HISTORY_FILTERS,
  GET_ADMIN_CHANGE_HISTORY_FILTER_ERROR,
  GET_ADMIN_CHANGE_HISTORY_FILTER_SUCCESS,
} from "./actionTypes"

export const getAdminChangeHistoryFilters = () => {
  return {
    type: GET_ADMIN_CHANGE_HISTORY_FILTERS,
  }
}

export const getAdminChangeHistoryFilterSuccess = (filterKey, data) => {
  return {
    type: GET_ADMIN_CHANGE_HISTORY_FILTER_SUCCESS,
    payload: { filterKey, data },
  }
}

export const getAdminChangeHistoryFilterError = (filterKey, error) => {
  return {
    type: GET_ADMIN_CHANGE_HISTORY_FILTER_ERROR,
    payload: { filterKey, error },
  }
}
